'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Entity=require('pulsar-utils/dist-es6/domain/entity');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');

const _setSerializer={
serialize:value=>_coerceNullable(value,_.toArray),
deserialize:value=>_coerceNullable(value,v=>new Set(v))};


const SETTING_TYPES_BY_ID={
groupsSidebarVisible:{
type:'boolean',
ensureExists:!0,
defaultValue:!0},

showAlertingOnly:{
type:'boolean',
defaultValue:!0},

showActiveOnly:{
type:'boolean',
defaultValue:!0},

selectedGroupId:{
type:'string',
validators:[_ensureGuidString]},

selectedIncidentTypeCode:{
type:'string'},

selectedIncidentBucketTypeLabel:{
type:'string'},

selectedForecastVisibleRangeOptionLabel:{
type:'string'},

selectedFlightMonitorVisibleRangeOptionLabel:{
type:'string'},

expandedSidebarGroups:{
type:Set,
validators:[_ensureAllValuesAreGuidStrings],
serializer:_setSerializer},

selectedNotificationType:{
type:NotificationType,
serializer:{
serialize:value=>_coerceNullable(value,v=>v.toBackend()),
deserialize:value=>_coerceNullable(value,NotificationType.fromBackend)}}};





if("production"==='test'){
const{DefaultAvailableDutyStatuses}=require('../../../dist-es6/client/features/emirates/emiratesDashboard/components/dutyStatusSelectorDirective/dutyStatusSelectorDirective');

_.assign(SETTING_TYPES_BY_ID,{
availableDutyStatuses:{
type:Set,
defaultValue:new Set(DefaultAvailableDutyStatuses),
validators:[_ensureNonZeroLengthArray],
serializer:_setSerializer},

selectedDutyStatuses:{
type:Set,
defaultValue:new Set,
serializer:_setSerializer},

staffSearchAutoRefreshOn:{
type:'boolean',
defaultValue:!1}});


};

const DEFAULT_STICKY_SETTINGS=_getDefaultStickySettings();

const TAB_SELECTION_TYPES=new Set([
'dashboardMain',
'notificationSettings',
'fleetInsightMain',
'fatigueTrends',
'personalSchedule']);


const PASSTHROUGH_SETTINGS=new Set([
..._.keys(SETTING_TYPES_BY_ID).filter(propertyId=>!_.exists(SETTING_TYPES_BY_ID[propertyId].serializer)),
..._.toArray(TAB_SELECTION_TYPES).map(_asTabSelectionProperty)]);


const ALL_STICKY_SETTINGS=new Set([
...PASSTHROUGH_SETTINGS.values(),
..._.keys(SETTING_TYPES_BY_ID).filter(propertyId=>_.exists(SETTING_TYPES_BY_ID[propertyId].serializer))]);let


StickySettings=class StickySettings extends Entity{
constructor(inputs,userId){
super(userId);

_assignGettersAndSettersForTabSelectionTypes(this);
_assignGettersAndSettersForTypeValidatedSettings(this);
_mapSettingsToObject(s=>inputs[s],this);
}

toJSON(){
return _mapSettingsToObject(setting=>StickySettings.serialize(setting,this[setting]));
}

static fromBackend(obj){
return new StickySettings(_mapSettingsToObject(setting=>StickySettings.deserialize(setting,obj[setting])),obj._id);
}

static isValidSetting(setting){
return ALL_STICKY_SETTINGS.has(setting);
}

static serialize(setting,value){
if(PASSTHROUGH_SETTINGS.has(setting)){
return value;
}

const serializer=_.get(SETTING_TYPES_BY_ID[setting],'serializer');
if(!_.exists(serializer)){
throw new Error(`Tried to serialize unknown setting '${setting}'`);
}

return serializer.serialize(value);
}

static deserialize(setting,value){
if(PASSTHROUGH_SETTINGS.has(setting)){
return value;
}

const serializer=_.get(SETTING_TYPES_BY_ID[setting],'serializer');
if(!_.exists(serializer.deserialize)){
throw new Error(`Tried to deserialize unknown setting '${setting}'`);
}

return serializer.deserialize(value);
}

static makeWithDefaultSettings(userId){
return new StickySettings(_.cloneDeep(DEFAULT_STICKY_SETTINGS),userId);
}};


function _asTabSelectionProperty(tabSelectionType){
return`${tabSelectionType}TabSelection`;
}

function _mapSettingsToObject(func,obj={}){
for(const setting of ALL_STICKY_SETTINGS){
obj[setting]=func(setting);
}
return obj;
}

function _getValidateNullableType(value,type,...additionalValidators){
if(!_.exists(value)){
return null;
}

_.ensureInstanceOf(type,value);
additionalValidators.forEach(validator=>validator(value));
return value;
}

function _coerceNullable(value,func=_.identity){
return _.exists(value)?func(value):null;
}

function _ensureGuidString(s){
_.ensureInstanceOf('string',s);
if(!Guid.isValid(s)){
throw new TypeError('expected Guid string');
}
}

function _ensureAllValuesAreGuidStrings(values){
return _.toArray(values).forEach(_ensureGuidString);
}

function _ensureNonZeroLengthArray(arr){
if(_.toArray(arr).length===0){
throw new Error(`Expected array to have at least 1 value: ${arr}`);
}
}

const _ignoredStickyTabSelectionIndexes={
personalSchedule:[2]};


function _isStickyTabSelectionIndex(tabSelectionType,index){
if(!_ignoredStickyTabSelectionIndexes[tabSelectionType]){
return!0;
}

return _ignoredStickyTabSelectionIndexes[tabSelectionType].indexOf(index)===-1;
}

function _assignGettersAndSettersForTabSelectionTypes(instance){
for(const tabSelectionType of TAB_SELECTION_TYPES.values()){
Object.defineProperty(instance,`${_asTabSelectionProperty(tabSelectionType)}`,{
get:()=>instance[`_${_asTabSelectionProperty(tabSelectionType)}`],
set:value=>{
if(!_isStickyTabSelectionIndex(tabSelectionType,value)){
return instance[`_${_asTabSelectionProperty(tabSelectionType)}`];
}

return instance[`_${_asTabSelectionProperty(tabSelectionType)}`]=_getValidateNullableType(value,'number');
}});

}
}

function _assignGettersAndSettersForTypeValidatedSettings(instance){
for(const propertyId in SETTING_TYPES_BY_ID){
const{
type,
validators=[],
ensureExists=!1}=
SETTING_TYPES_BY_ID[propertyId];

if(!_.exists(type)){
throw new Error(`StickySetting property definition for "${propertyId}" does not have a defined 'type' which is required for validation. Refusing to initialize StickySettings.`);
}

const _privatePropertyName=`_${propertyId}`;

Object.defineProperty(instance,propertyId,{
get:()=>instance[_privatePropertyName],
set:ensureExists?
value=>{
_.ensureInstanceOf(type,value);
validators.forEach(validator=>validator(value));
return instance[_privatePropertyName]=value;
}:
value=>instance[_privatePropertyName]=_getValidateNullableType(value,type,...validators)});

}
}

function _getDefaultStickySettings(){
const defaultSettings={};

for(const propertyId in SETTING_TYPES_BY_ID){
if(!_.has(SETTING_TYPES_BY_ID[propertyId],'defaultValue')){
continue;
}
defaultSettings[propertyId]=SETTING_TYPES_BY_ID[propertyId].defaultValue;
}

return defaultSettings;
}

module.exports=StickySettings;
//# sourceMappingURL=stickySettings.js.map
